import { useEffect } from "react";
import "@/App.css";
import { T } from "@/content";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { Clients } from "@/components/site/Clients";
import { About } from "@/components/site/About";
import { Roles } from "@/components/site/Roles";
import { Credentials } from "@/components/site/Credentials";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import { useReveal } from "@/components/site/useReveal";

const lang = "en";

function App() {
  const t = T[lang];
  useReveal(lang);

  useEffect(() => {
    document.documentElement.lang = "en";
    document.documentElement.dir = "ltr";
    localStorage.removeItem("jz-lang");
  }, []);

  return (
    <div className="site min-h-screen" dir="ltr" data-testid="site-root">
      <Nav t={t} />
      <main>
        <Hero t={t} />
        <Clients t={t} lang={lang} />
        <About t={t} />
        <Roles t={t} lang={lang} />
        <Credentials t={t} />
        <Contact t={t} />
      </main>
      <Footer t={t} />
    </div>
  );
}

export default App;
